/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Password_ResetInputs */



/**
* | output |
* | --- |
* | "Failed to send password reset email. Please check your email address." |
*
* @param {Login_Error_Password_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_password_reset = /** @type {((inputs?: Login_Error_Password_ResetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Password_ResetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'envoi de l'email de réinitialisation du mot de passe. Veuillez vérifier votre adresse email.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die E-Mail zum Zurücksetzen des Passworts konnte nicht gesendet werden. Bitte überprüfen Sie Ihre E-Mail-Adresse.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile inviare l'email per reimpostare la password. Controlla il tuo indirizzo email.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось отправить письмо для сброса пароля. Пожалуйста, проверьте свой адрес электронной почты.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo enviar el correo electrónico de restablecimiento de contraseña. Por favor, revise su dirección de correo electrónico.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("密码重置邮件发送失败。请检查您的邮箱地址。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードリセットメールを送信できませんでした。メールアドレスをご確認ください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पासवर्ड रीसेट करने के लिए ईमेल भेजने में विफलता। कृपया अपना ईमेल पता जांचें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao enviar o e-mail de redefinição de senha. Verifique seu endereço de e-mail.")
	return /** @type {LocalizedString} */ ("Failed to send password reset email. Please check your email address.")
});